import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import { updateCargoOrder } from 'actions/cargoes/orders';

const typeTerms = [
    'POL dets:',
    'POD dets:',
    'POL/POD dets:',
    'Laycan dets:',
    'Load dets:',
    'Disch dets:',
    'L/D dets:',
    'Comm dets:',
    'Freight dets:',
    'Vessel dets:',
    'Packing dets:',
    'Additional dets:',
    'Cargo dets:',
];

class Terms extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: [],
        };

        this.onChangeTerm = this.onChangeTerm.bind(this);
        this.addNewTerm = this.addNewTerm.bind(this);
        this.removeTerm = this.removeTerm.bind(this);
        this.showError = this.showError.bind(this);
        this.onChangeTypeTerm = this.onChangeTypeTerm.bind(this);
    }

    removeTerm(number) {
        this.deleteError(number);
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        newCargoOrder.terms.user.splice(number, 1);
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    addNewTerm() {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        newCargoOrder.terms.user.push({ type: '', value: '' });
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    onChangeTypeTerm(key, numberElement) {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        newCargoOrder.terms.user[numberElement].type = typeTerms[key];
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    onChangeTerm(value, numberElement) {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        newCargoOrder.terms.user[numberElement].value = value;
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    deleteError(key) {
        const errors = this.state.errors.filter((error) => {
            return error.key !== key;
        });

        this.setState({
            errors,
        });
    }

    showError(key) {
        const errorObject = this.state.errors.find((error) => {
            return error.key === key;
        });

        return errorObject ? errorObject.text : '';
    }

    render() {
        return (
            <div>
                <div className='row'>
                    <div className='column-left'>
                        Terms:
                    </div>
                    <div className='column-right'>
                        <RaisedButton
                            labelStyle={{ fontSize: '10px' }}
                            style={{ height: '25px' }}
                            buttonStyle={{ height: '25px', lineHeight: '25px' }}
                            label='Add new term'
                            onClick={this.addNewTerm}
                            primary
                        />
                    </div>
                </div>
                {
                    this.props.cargoOrder.terms.user.map((term, key) => {
                        const errorMessage = this.showError(key);
                        return (
                            <div key={key} className='row'>
                                <div className='column-left'>
                                    {`Term ${key}`}
                                </div>
                                <div className='column-right'>
                                    <SelectField
                                        style={{
                                            padding: '0 5px',
                                            width: '80%',
                                            fontSize: '13px',
                                        }}
                                        defaultValue={term.type}
                                        value={term.type}
                                        onChange={(e, numberSelected) => {
                                            this.onChangeTypeTerm(numberSelected, key);
                                        }}
                                        maxHeight={200}
                                        autoWidth
                                    >
                                        {
                                            typeTerms.map((typeTerm, i) => {
                                                return (<MenuItem
                                                    key={i}
                                                    style={{ width: 'auto', fontSize: '13px' }}
                                                    value={typeTerm}
                                                    primaryText={typeTerm}
                                                />);
                                            })
                                        }
                                    </SelectField>
                                    <TextField
                                        style={{ fontSize: '13px' }}
                                        value={term.value}
                                        hintText={`Term ${key}`}
                                        errorText={errorMessage}
                                        onChange={(e) => { return this.onChangeTerm(e.target.value, key); }}
                                    />
                                    <RaisedButton
                                        labelStyle={{ fontSize: '10px' }}
                                        style={{ height: '25px' }}
                                        buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                        label='Remove term'
                                        onClick={() => { return this.removeTerm(key); }}
                                        secondary
                                    />
                                </div>
                            </div>);
                    })
                }
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {

        return {
            numberOrderTable: ownProps.numberOrderTable,
            validateErrors: state.cargoOrders.items[ownProps.numberOrderTable].validateErrors,
            cargoOrder: state.cargoOrders.items[ownProps.numberOrderTable],
        };
    },
    dispatch => bindActionCreators({
        updateCargoOrder,
    }, dispatch),
)(Terms);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/Terms.jsx